import { render, staticRenderFns } from "./ClientPortalView.vue?vue&type=template&id=31c3ac7e&"
import script from "./ClientPortalView.vue?vue&type=script&lang=js&"
export * from "./ClientPortalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports